/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function ListStyleDisc(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'ListStyleDisc',
      'aria-hidden': true,
      focusable: false,
      width:  16 * scale,
      height: 16 * scale,
      viewBox: '0 0 16 16',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('rect', {"x":"1","y":"2","width":"4","height":"4","rx":"2","fill":"currentColor"}),createElement('rect', {"x":"1","y":"10","width":"4","height":"4","rx":"2","fill":"currentColor"}),createElement('path', {"opacity":".6","fillRule":"evenodd","clipRule":"evenodd","d":"M15 3H7v2h8V3zm0 8H7v2h8v-2z","fill":"currentColor"}))
}
